import { Heart } from 'lucide-react';
import { DeferredAuthModal } from '@/components/auth/deferred-auth-modal';
import { Button } from '@upzi/web-shell/ui/button';
import { cn } from '@/lib/utils';

type JobSaveButtonProps = {
  className?: string;
  isPending?: boolean;
  isSaved?: boolean;
  onSaveChange?: () => Promise<void> | void;
  requiresLogin?: boolean;
  showLabel?: boolean;
  variant?:
    | 'link'
    | 'black'
    | 'default'
    | 'destructive'
    | 'outline'
    | 'secondary'
    | 'ghost'
    | null;
};

export function JobSaveButton({
  variant,
  className,
  isPending = false,
  isSaved = false,
  onSaveChange,
  requiresLogin = false,
  showLabel = false,
}: JobSaveButtonProps) {
  const button = (
    <Button
      type="button"
      variant={variant || 'outline'}
      size={showLabel ? 'default' : 'icon'}
      aria-label={isSaved ? 'Gỡ lưu việc làm' : 'Lưu việc làm'}
      aria-pressed={isSaved}
      data-state={isSaved ? 'active' : 'inactive'}
      disabled={isPending || (!requiresLogin && !onSaveChange)}
      onClick={event => {
        event.stopPropagation();

        return onSaveChange?.();
      }}
      className={cn(
        'job-card-save pointer-events-auto shrink-0',
        showLabel
          ? 'text-ui-base leading-ui-base h-10 gap-1.5 rounded-xl px-4 font-medium has-[>svg]:px-4'
          : 'size-8 rounded-lg sm:size-9 sm:rounded-xl',
        className,
        isSaved && 'text-negative hover:text-negative'
      )}
    >
      <Heart
        aria-hidden
        className={cn(
          showLabel ? 'size-4' : 'size-5',
          isSaved && 'fill-current'
        )}
      />
      {showLabel ? (isSaved ? 'Đã lưu' : 'Lưu') : null}
    </Button>
  );

  if (!requiresLogin) return button;

  return (
    <span
      className="pointer-events-auto inline-flex shrink-0"
      onClick={event => event.stopPropagation()}
      onPointerDown={event => event.stopPropagation()}
    >
      <DeferredAuthModal authenticatedContent={button} triggerButton={button} />
    </span>
  );
}
